import { render, staticRenderFns } from "./loan-collateral.vue?vue&type=template&id=a8e4b392"
import script from "./loan-collateral.vue?vue&type=script&lang=js"
export * from "./loan-collateral.vue?vue&type=script&lang=js"
import style0 from "./loan-collateral.vue?vue&type=style&index=0&id=a8e4b392&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../AppData/Roaming/nvm/v12.14.1/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports